import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { FETCH_START, FETCH_SUCCESS, FETCH_ERROR } from '../../constants/ActionTypes';
import customAxios from '../../util/Api';
import authHeader from '../../../../services/auth/jwt/auth-header';

const useSPList = () => {
  const dispatch = useDispatch();
  const [spList, setSPList] = useState([]);
  const [spListObj, setSPListObj] = useState({});

  const getSPList = () => {
    try {
      dispatch({ type: FETCH_START });
      customAxios.get('/Ops/GetContracts', { headers: authHeader() }).then(response => {
        let allData = response.data || [];

        let uniqueData = [];
        let uniqueDataObj = {};
        for (let i = 0; i < allData.length; i++) {
          let sp = allData[i];
          if (sp.contractUniqueID) {
            const rawValue = sp.contractUniqueID;
            const item = {
              value: rawValue,
              label: `${rawValue} - ${sp.wH_NumberName}`,
            };

            uniqueData.push(item);
            uniqueDataObj[rawValue] = { ...sp, ...item };
          }
        }

        setSPList(uniqueData);
        setSPListObj(uniqueDataObj);
        dispatch({ type: FETCH_SUCCESS });
      });
    } catch (error) {
      setSPList([]);
      setSPListObj({});
      dispatch({ type: FETCH_ERROR, payload: 'Network Error' });
    }
  };

  useEffect(() => {
    getSPList();
  }, []);

  return { spList, spListObj, refreshSPList: getSPList };
};

export default useSPList;
